import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { LoaderComponent } from 'components/Loader';

export const LoaderWrapper = styled.div`
  width: ${scaleSize(384)}px;
  height: ${scaleSize(558)}px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  margin: auto;
  bottom: 0;
`;

export default () => (
  <LoaderWrapper>
    <LoaderComponent />
  </LoaderWrapper>
);
